<!-- desktop -->
<div class="container-fluid text-center fontWhite py-3 d-none d-xxl-block d-xl-block d-lg-block d-md-block"
  style="background-color: #304771;">
  <h4 class="fontWhite" style="text-decoration: underline;">ช่องทางการติดต่อ</h4>
  <div class="container">
    <div class="row justify-content-center mb-2">
      <span class="mr-3">
        <img src="assets/phone-call.png" width="20px" height="20px" class="mr-2">
        <a href="tel:022181311">02-218-1311</a>
      </span>
      <span class="mr-3">
        <img src="assets/email.png" width="20px" height="20px" class="mr-2">
        <a href="mailto:chulalifedi@gmail.com" target="_blank">chulalifedi@gmail.com</a>
      </span>
      <span>
        <img src="assets/facebook (white).png" width="20px" height="20px" class="mr-2">
        <a href="https://www.facebook.com/ChulaLifeDi" target="_blank">
          Life Di ศูนย์จิตวิทยาพัฒนาการและความสัมพันธ์ระหว่างวัย จุฬาฯ
        </a>
      </span>
    </div>
    <div class="row justify-content-center">
      <!-- <a [href]="this.locationUrl + '/privacy-policy'" class="mr-3">Privacy Policy</a> -->
      <span>Copyright © 2021 ChulaLifeDi : ศูนย์จิตวิทยาพัฒนาการและความสัมพันธ์ระหว่างวัย จุฬาลงกรณ์มหาวิทยาลัย</span>
    </div>
  </div>
</div>

<!-- mobile -->
<div class="container-fluid text-center py-3 fontWhite d-none d-block d-sm-none d-sm-block d-md-none "
  style="background-color: #304771;">
  <h4 class="fontWhite" style="text-decoration: underline;">ช่องทางการติดต่อ</h4>
  <div class="container">
    <div class="row justify-content-center my-1">
      <span>
        <img src="assets/phone-call.png" width="20px" height="20px" class="mr-2">
        <a href="tel:022181311">02-218-1311</a>
      </span>
    </div>
    <div class="row justify-content-center my-1">
      <span>
        <img src="assets/email.png" width="20px" height="20px" class="mr-2">
        <a href="mailto:chulalifedi@gmail.com" target="_blank">chulalifedi@gmail.com</a>
      </span>
    </div>
    <div class="row justify-content-center my-1 mx-1">
      <span>
        <img src="assets/facebook (white).png" width="20px" height="20px" class="mr-2">
        <a href="https://www.facebook.com/ChulaLifeDi" target="_blank">
          Life Di ศูนย์จิตวิทยาพัฒนาการและความสัมพันธ์ระหว่างวัย จุฬาฯ
        </a>
      </span>
    </div>
    <div class="row justify-content-center">
      <!-- <a [href]="this.locationUrl + '/privacy-policy'">Privacy Policy</a> -->
    </div>
    <div class="row justify-content-center">
      <span>Copyright © 2021 ChulaLifeDi : <br> ศูนย์จิตวิทยาพัฒนาการและความสัมพันธ์ระหว่างวัย
        จุฬาลงกรณ์มหาวิทยาลัย</span>
    </div>
  </div>
</div>
